<template>
  <div class="background-01">
    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only ">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Existen diferentes tipos de gastos" titleLevel="h1">
          <template slot="partOne">Otra división<br></template>
          <template slot="partThree"> de los gastos</template>
        </ui-title-one>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="animated fadeInUp dura_1">
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Gasto esenciales y no esenciales'" videoEmbed="ADMINISTRACIONDINERO29DiferentesTiposDeGastosb.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12>
        <p>Los gastos <strong>fijos y variables</strong> se dividen en gastos <strong>esenciales y no esenciales</strong>. Al tener claro cuáles son 
          esenciales y cuáles  no, es más fácil realizar un presupuesto.<br><br>
          <span class="offscreen">Pase el cursor o dé enter sobre cada tipo de gasto para descubrir su definición</span></p>
      </v-flex>      
    </v-layout>
    
    <button-expand-cont class="animated fadeInUp dura_2" :contenidos="contenidos"></button-expand-cont>

  </div>
</template>

<script>
export default {
  data() {
    return {
      contenidos: [
        {
          nombre: 'Gastos esenciales',
          texto: `Son aquellos que necesariamente se deben realizar, ya que satisfacen las <strong>necesidades básicas</strong> de 
          la calidad de vida: la vivienda, la comida, el vestido, la educación, entre otros.`,
          visto: false
        },
        {
          nombre: 'Gastos no esenciales',
          texto: `Son aquellos de los cuales <strong>se puede prescindir</strong> sin afectar con severidad la calidad de vida, como el licor, 
          las celebraciones, los regalos costosos, entre otros.`,
          visto: false
        }
      ]
    };
  },
  mounted() {
    this.$store.commit("nextShow", false);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-29.vue?996c801a